import { DeviceEventMap } from 'shared/models';

export const Actions = {
    GET_DEVICE_EVENTS_REQUEST: 'GET_DEVICE_EVENTS_REQUEST',
    GET_DEVICE_EVENTS_SUCCESS: 'GET_DEVICE_EVENTS_SUCCESS',
    GET_DEVICE_EVENTS_FAILURE: 'GET_DEVICE_EVENTS_FAILURE',
};

export const getDeviceEventsRequest = (deviceId: string, options: { olderThan?: number; newerThan?: number; rows?: number } = {}) => ({
    type: Actions.GET_DEVICE_EVENTS_REQUEST,
    payload: deviceId,
    meta: options,
});
export const getDeviceEventsSuccess = (deviceId: string, events: DeviceEventMap, more: boolean) => ({
    type: Actions.GET_DEVICE_EVENTS_SUCCESS,
    payload: events,
    meta: { deviceId, more },
});
export const getDeviceEventsFailure = (deviceId: string, err: Error) => ({
    type: Actions.GET_DEVICE_EVENTS_FAILURE,
    payload: err,
    error: true,
    meta: { deviceId },
});
